import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface CardProps {
  children: ReactNode
  className?: string
  href?: string
  hover?: boolean
}

export function Card({ children, className = '', href, hover = true }: CardProps) {
  const baseStyles = `bg-white rounded-xl border border-slate-200 ${
    hover ? 'transition-shadow hover:shadow-lg hover:border-slate-300' : ''
  } ${className}`

  if (href) {
    return (
      <Link to={href} className={`block ${baseStyles}`}>
        {children}
      </Link>
    )
  }

  return <div className={baseStyles}>{children}</div>
}

interface CardHeaderProps {
  children: ReactNode
  className?: string
}

export function CardHeader({ children, className = '' }: CardHeaderProps) {
  return <div className={`p-6 pb-0 ${className}`}>{children}</div>
}

interface CardContentProps {
  children: ReactNode
  className?: string
}

export function CardContent({ children, className = '' }: CardContentProps) {
  return <div className={`p-6 ${className}`}>{children}</div>
}

interface CardFooterProps {
  children: ReactNode
  className?: string
}

export function CardFooter({ children, className = '' }: CardFooterProps) {
  return <div className={`px-6 pb-6 pt-0 ${className}`}>{children}</div>
}
